'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _GoodFiltersAndPage$M;

import _ from 'underscore';
import GoodFiltersAndPage from './GoodFiltersAndPage';
import CustomModulePurposeOptionsArray from './CustomModulePurposeOptionsArray';
import GoodSubTypes from './GoodSubTypes';
import TemplatePurposeOptionsArray from './TemplatePurposeOptionsArray';

var SUB_TYPES = _.without(_.values(GoodSubTypes), GoodSubTypes.ALL, GoodSubTypes.NONE);

export default (_GoodFiltersAndPage$M = {}, _defineProperty(_GoodFiltersAndPage$M, GoodFiltersAndPage.MODULE_PURPOSE, CustomModulePurposeOptionsArray), _defineProperty(_GoodFiltersAndPage$M, GoodFiltersAndPage.SUB_TYPE, SUB_TYPES), _defineProperty(_GoodFiltersAndPage$M, GoodFiltersAndPage.TEMPLATE_PURPOSE, TemplatePurposeOptionsArray), _GoodFiltersAndPage$M);